import React, { ChangeEvent, useState } from "react";
import Select from 'react-select';
import styled from "styled-components";
import { InputProps } from "../../../interfaces/interfaces";
export type SelectTextFieldOption = {
  name: string;
  value: string;
  label: string;
}
export type SelectTextFieldProps = {
  options: SelectTextFieldOption[]
} & InputProps

export const SelectTextField: React.FC<SelectTextFieldProps> = ({ options, className, onChange, placeholder, required }) => {

  const [selectedOption, setSelectedOption] = useState(null);
  const handleOnChange = (option: any) => {
    setSelectedOption(option)
    onChange && onChange(option)
  }
  return (
    <div className={className}>
      {/* <pre>{JSON.stringify({ options }, null, 4)}</pre> */}
      <Select
        classNamePrefix="react-select"
        defaultValue={selectedOption}
        onChange={handleOnChange}
        options={options}
        placeholder={placeholder}
        required={required}
      />
    </div>
  );
}
